// 正式
export default {
  bucketName: 'prod-ubq',
  cdnUrl: 'https://obs.prod.ubanquan.cn',
  // 优版权obs cdn
  cdnMLMUrl: 'https://obs.prodipbank.ubanquan.cn',
  // 漫联盟obs cdn
  cdnBWLUrl: 'https://obs.prodbwl.ubanquan.cn',
  // obs博物联
  haiXinUrl: 'https://haixing.tianhecloud.com/#/oauth' // 海星钱包 线上地址
};